import { AxisMode, AxisType } from "../interfaces/axis";
import { GraphCommand, GraphType, } from "../interfaces/config";
import * as d3 from "../assets/d3";
import { setElementColor, createGraphElement } from "./element";
import produce from "immer";
import { generateSimpleStruct } from "./struct";
import { colorSchemes, colorSchemesNames } from "@focus/focusUI";
export const createBahnGraphConfig = () => {
    return {
        format: "Bahn",
        selectorFolderList: [
            {
                id: "selector01",
                title: "selector01",
                type: "defined",
                selectorList: [],
            },
        ],
        customSelectorFolderList: [],
    };
};
export const addGraph = (config, graph) => {
    const tab = createTab([graph], graph.title);
    const display = createDisplay([tab], tab.title);
    const finalConfig = addDisplay(config, display);
    return finalConfig;
};
export const createTab = (graphs, title) => {
    const singleTab = {
        title: title,
        id: "",
        command: "",
        struct: undefined,
        graphs: graphs,
    };
    return singleTab;
};
export const createDisplay = (grafosTabs, title) => {
    const singleDisplay = {
        id: "",
        title: title,
        tabs: grafosTabs,
        state: false,
    };
    return singleDisplay;
};
export const addDisplay = (config, display) => {
    let numberOftabs = 0;
    let numberOfGraphs = 0;
    const finalConfig = produce(config, (draft) => {
        draft.selectorFolderList[0].selectorList.push(display);
        draft.selectorFolderList[0].selectorList.forEach((display, index) => {
            display.id = "DISP" + index;
            display.tabs.forEach((tab) => {
                tab.id = "TAB" + numberOftabs;
                tab.struct = generateSimpleStruct(numberOftabs);
                numberOftabs++;
                tab.graphs.map((singleGraphs) => {
                    singleGraphs.id = "GRAPH" + numberOfGraphs;
                    numberOfGraphs++;
                });
            });
        });
    });
    return finalConfig;
};
export const removeGraph = (config, graphId) => {
    return produce(config, (draft) => {
        draft.selectorFolderList[0].selectorList.forEach((display, index) => {
            display.tabs.forEach((tab) => {
                tab.graphs.forEach((singleGraph) => {
                    if (singleGraph.id === graphId) {
                        draft.selectorFolderList[0].selectorList.splice(index, 1);
                    }
                });
            });
        });
        return draft;
    });
};
export const assignColorsToGraph = (graph, colorPalette) => {
    const values = graph.elements.map((element) => element.colY);
    const scale = createColorScale(values, colorPalette);
    const updatedElements = graph.elements.map((ele) => setElementColor(ele, scale(ele.colY)));
    return Object.assign(Object.assign({}, graph), { elements: updatedElements });
};
export const addElement = (graph, graphElement, colorPalette) => {
    const newGraph = Object.assign(Object.assign({}, graph), { elements: [...graph.elements, graphElement] });
    return assignColorsToGraph(newGraph, colorPalette);
};
export const createGraph = (title, xTitle, yTitle, dateXAxis, hideGrid) => {
    const xAxis = createAxis(AxisType.x, xTitle, dateXAxis ? AxisMode.Date : AxisMode.Linear);
    const yAxis = createAxis(AxisType.y, yTitle, AxisMode.Linear);
    return {
        axes: [xAxis, yAxis],
        command: GraphCommand.graph,
        elements: [],
        grid: !hideGrid,
        id: "",
        objects: [],
        surfaces: [],
        title: title,
        type: GraphType.Normal,
    };
};
export const createAxis = (type, title, mode) => {
    return {
        color: "black",
        maxValue: null,
        minValue: null,
        mode,
        title,
        type,
        width: 1,
    };
};
const setXValue = (graph, xValue, title) => {
    return produce(graph, (draft) => {
        const xAxisMode = xValue === "date" ? AxisMode.Date : AxisMode.Linear;
        draft.elements = draft.elements.map((ele) => (Object.assign(Object.assign({}, ele), { colX: xValue })));
        const xAxis = draft.axes.find((axis) => axis.type === AxisType.x);
        xAxis.mode = xAxisMode;
        xAxis.title = title;
        return draft;
    });
};
const createColorScale = (Values, colorScheme) => d3
    .scaleOrdinal(Values.map((_, i) => d3.color(colorSchemes[colorScheme](i / Values.length)).hex()))
    .domain(Values);
export const setXValueGraph = (config, graphId, xValue, title) => {
    return produce(config, (draft) => {
        draft.selectorFolderList[0].selectorList.forEach((display) => {
            display.tabs.forEach((tab) => {
                tab.graphs.forEach((singleGraph, index) => {
                    if (singleGraph.id === graphId) {
                        tab.graphs[index] = setXValue(tab.graphs[index], xValue, title);
                    }
                });
            });
        });
        return draft;
    });
};
export const addElementToGraph = (config, graphId, graph, colX, colY, file, colorPalette = colorSchemesNames.SINEBOW) => {
    return produce(config, (draft) => {
        const newElement = createGraphElement(graph, colX, colY, file);
        draft.selectorFolderList[0].selectorList.forEach((display) => {
            display.tabs.forEach((tab) => {
                tab.graphs.forEach((singleGraph, index) => {
                    if (singleGraph.id === graphId) {
                        tab.graphs[index] = addElement(tab.graphs[index], newElement, colorPalette);
                    }
                });
            });
        });
        return draft;
    });
};
export const removeElement = (config, graphId, colId, colorPalette = colorSchemesNames.SINEBOW) => {
    return produce(config, (draft) => {
        draft.selectorFolderList[0].selectorList.forEach((display) => {
            display.tabs.forEach((tab) => {
                tab.graphs.forEach((singleGraph, index) => {
                    if (singleGraph.id === graphId) {
                        singleGraph.elements = singleGraph.elements.filter((ele) => ele.colY !== colId);
                        tab.graphs[index] = assignColorsToGraph(tab.graphs[index], colorPalette);
                    }
                });
            });
        });
        return draft;
    });
};
export const cleanElements = (config, graphId) => {
    return produce(config, (draft) => {
        draft.selectorFolderList[0].selectorList.forEach((display) => {
            display.tabs.forEach((tab) => {
                tab.graphs.forEach((singleGraph) => {
                    if (singleGraph.id === graphId)
                        singleGraph.elements = [];
                });
            });
        });
        return draft;
    });
};
export const setGraphType = (config, graphId, type) => {
    return produce(config, (draft) => {
        draft.selectorFolderList[0].selectorList.forEach((display) => {
            display.tabs.forEach((tab) => {
                tab.graphs.forEach((singleGraph) => {
                    if (singleGraph.id === graphId) {
                        singleGraph.type = type;
                    }
                });
            });
        });
        return draft;
    });
};
export const setGraphTitle = (config, graphId, title) => {
    return produce(config, (draft) => {
        draft.selectorFolderList[0].selectorList.forEach((display) => {
            display.tabs.forEach((tab) => {
                tab.graphs.forEach((singleGraph) => {
                    if (singleGraph.id === graphId) {
                        tab.title = title;
                        singleGraph.title = title;
                    }
                });
            });
        });
        return draft;
    });
};
export const getSelectedDisplays = (config) => {
    if (config.selectorFolderList.length) {
        return config.selectorFolderList.reduce((previous, current) => previous.concat(current.selectorList
            .filter((singleDisplay) => singleDisplay.state)
            .map((single) => single.id)), []);
    }
    return [];
};
//# sourceMappingURL=graph.js.map